import "./CadastroAutomationButtons.css";
import { useEffect, useState } from "react";
import FormAutomationButtons from "../FormAutomationButtons/FormAutomationButtons";
import { useListManager } from "../../../contexts/list.manager";
import { useLocation, useParams } from "react-router-dom";
import CadastroContainer from "../../../components/CadastroContainer/CadastroContainer";
import AutomationButtonService from "../../../services/AutomationButtonService";

const CadastroAutomationButtons = () => {
	const { automationButtonId } = useParams();
	const { state } = useLocation();
	const { lineSelected } = useListManager();
	const [automationButton, setAutomationButton] = useState(state);
	const [formMode, setFormMode] = useState("");

	async function loadAutomationButton(id) {
		const response = await AutomationButtonService.getOne(id);
		if (response.data) {
			setAutomationButton(response.data);
		}
	}

	useEffect(() => {
		setFormMode(automationButtonId || lineSelected ? "edicao" : "cadastro")

		if (automationButton) {
			setAutomationButton(state);
			return;
		}
		if (automationButtonId) {
			loadAutomationButton(automationButtonId);
		}
	}, [lineSelected, state, automationButtonId]);

	return (
		<CadastroContainer>
			<FormAutomationButtons
				automationButton={automationButton}
				formMode={formMode}
			/>
		</CadastroContainer>
	);
};

export default CadastroAutomationButtons;
